export default {
  GET_FACILITIES(state, data) {
    state.facilities = data.data;
  },
  GET_ALL_FACILITIES(state, data) {
    state.all_facilities = data.data;
  },
  GET_FACILITY(state, data) {
    state.facility = data.data[0];
  },
  GET_EXTERNAL_FACILITY(state, data) {
    state.external_facility = data.data[0];
    state.single_external_facilty_price = data.data[0].price;
  },
  GET_DELETED_FACILITIES(state, data) {
    state.deleted_facilities = data.data;
  },
  GET_ACTIVE_CAMPING(state, data) {
    state.active_camping = data.data;
  },
  GET_ACTIVE_FACILITIES(state, data) {
    state.active_facilities = data.data;
  },
  GET_IN_ACTIVE_FACILITIES(state, data) {
    state.inactive_facilities = data.data;
  },
  GET_ACTIVE_ACCOMMODATION(state, data) {
    state.active_accommodations = data.data;
  },
  GET_ACTIVE_ACCOMMODATION_CAMPSITE(state, data) {
    state.active_accommodation_campsite = data.data;
  },
  FACILITY_UNAVAILABILITY(state, data) {
    state.facility_unavailability_schedule = data.data;
  },
  FACILITY_SURGE(state, data) {
    state.surge_schedule = data.data;
  },
  RECOMMENDED_CAMPING(state, data) {
    state.recommended_camping = data.data;
  },
  RECOMMENDED_ACCOMMODATION(state, data) {
    state.recommended_accommodation = data.data;
  },
  GET_FACILITY_IMAGES(state, data) {
    state.facility_images = data.data;
  },
  GET_FACILITY_AVAILABILITY(state, data) {
    let availability = data.facility_data;
    availability = availability.concat(data.camping_data);
    state.available_facilities = availability;
  },
  GET_EXTERNAL_FACILITY_AVAILABILITY(state, data) {
    let availability = data.facility_data;
    state.available_external_facilities = availability;
  },

  BOOKING_FACILITIES(state, data) {
    state.chosenFacilities = data;
  },
  BROWSER_FACILITIES(state, data) {
    state.browser_facilities = data;
  },
  CAMPING_MULTI_DATA(state, data) {
    state.camping_multi_browser_facilities = data;
  },
  ADD_FACILITY(state, data) {
    state.chosenFacilities.push(data);
  },
  CONFIRMED_EXTERNAL_FACILITY(state, data) {
    state.chosenExternalFacility.push(data);
  },
  ADD_CAMPING_MULTI(state, data) {
    state.multi_camping_arrivals.push(data);
  },
  NEW_EXTERNAL_FACILITY(state, data) {
    state.new_external_facility_data.push(data);
  },
  CONFIRM_EXTERNAL_FACILITY(state, data) {
    state.confirmed_external_facility_data.push(data);
  },
  REMOVE_MULTI_ARRIVAL(state, data) {
    state.multi_camping_arrivals.splice(
      state.multi_camping_arrivals.indexOf(data),
      1
    );
  },
  REMOVE_EXTERNAL_FACILITY(state, data) {
    state.new_external_facility_data.splice(
      state.new_external_facility_data.indexOf(data),
      1
    );
  },
  REMOVE_CONFIRMED_EXTERNAL_FACILITY(state, data) {
    state.chosenExternalFacility.splice(
      state.chosenExternalFacility.indexOf(data),
      1
    );
  },
  REMOVE_ALREADY_BOOKED_EXTERNAL_FACILITY(state, data) {
    state.bookedExternalFacilities.splice(
      state.bookedExternalFacilities.indexOf(data)
    );
  },
  REMOVE_FACILITY(state, data) {
    state.chosenFacilities.splice(state.chosenFacilities.indexOf(data), 1);
  },
  REMOVE_BOOKED_FACILITY(state, data) {
    state.bookedFacilities.splice(state.bookedFacilities.indexOf(data), 1);
  },
  ADD_BOOKED_FACILITY(state, data) {
    state.bookedFacilities.push(data);
  },
  REMOVE_CHOSEN_FACILITIES(state) {
    state.chosenFacilities = [];
    state.chosenExternalFacility = [];
    state.bookedExternalFacilities = [];

  },
  REMOVE_AVAILABLE_FACILITIES(state) {
    state.available_facilities = [];
  },
  REMOVE_CHOSEN_EXTERNAL_FACILITIES(state) {
    state.chosenExternalFacility = [];
  },
  REMOVE_EXTERNAL_FACILITIES(state) {
    state.new_external_facility_data = [];
  },

  REMOVE_MULTI_ARRIVALS(state) {
    state.multi_camping_arrivals = [];
    state.camping_multi_browser_facilities = [];
  },
  ALREADY_BOOKED_FACILITIES(state, data) {
    state.bookedFacilities = data;
  },
  ALREADY_BOOKED_EXTERNAL_FACILITIES(state, data) {
    state.bookedExternalFacilities = data;
  },

  SINGLE_EXTERNAL_FACILITY_PRICE(state, data) {
    state.single_external_facilty_price = data;
  },
  REVENUE_SPLIT(state, data) {
    state.revenue_split_percent = data;
  }
};
